"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var SubstitutedUserConverter_1 = require("./conversions/SubstitutedUserConverter");

var SubstitutedUserConverterImpl_1 = require("./conversions/SubstitutedUserConverterImpl");

var UserInfoConverter_1 = require("./conversions/UserInfoConverter");

var UserInfoConverterImpl_1 = require("./conversions/UserInfoConverterImpl");

var UserProfileConverter_1 = require("./conversions/UserProfileConverter");

var UserProfileConverterImpl_1 = require("./conversions/UserProfileConverterImpl");
/**
 * User authorization and management feature of application.
 *
 * @author Radek Beran
 */


var UserAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(UserAppModule, _AppModule_1$AppModul);

  function UserAppModule() {
    var _this;

    _classCallCheck(this, UserAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'user';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(UserAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(SubstitutedUserConverter_1.SubstitutedUserConverter).to(SubstitutedUserConverterImpl_1.SubstitutedUserConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(UserInfoConverter_1.UserInfoConverter).to(UserInfoConverterImpl_1.UserInfoConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(UserProfileConverter_1.UserProfileConverter).to(UserProfileConverterImpl_1.UserProfileConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return UserAppModule;
}(AppModule_1.AppModule);

exports.UserAppModule = UserAppModule;